/* eslint-disable import/no-unresolved,camelcase */
import { Icon } from 'antd';
import React, { useState } from 'react';

import axios from 'axios';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { SV_SOJ_ORCMOCK_ADDRESS } from '../constants';
import '../css/svlist_styles.css'
const headers = {'Content-Type': 'application/json'}

/* example-start */
const SEARCH_URI = 'https://api.github.com/search/users';
/*
const fetch = require('node-fetch');
const https = require('https');
const headers = {'Content-Type': 'application/json'}


const httpsAgent = new https.Agent({
      rejectUnauthorized: false,
    });

*/
        
const SVRSojournDest = (props) => {
  console.log('sv*******SVRAiport********prrops')
  console.log(props)
  const {onSearchDesttxtFancy} = props
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDest, setSelectedDest] = useState([]);
  const [iatas, setIatas] = useState([]);
  const [svdest, setSvdest] = useState('TT');
  console.log('sv**APR7*****SVRAiport********svdest', svdest)

  const [options, setOptions] = useState([]);

  const handleSearch = (query) => {
    setIsLoading(true);
//fetch(`${SEARCH_URI}?q=${query}+in:login&page=1&per_page=50`)
    const svairporturl = `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsearchsojourn?subType=AIRPORT&keyword=${query}&countryCode=US`
    const svairporturlBAse =  `${SV_SOJ_ORCMOCK_ADDRESS}/sojournpoint/svsearchsojourn`
//const svairporturl = `${SV_SOJ_ORCMOCK_ADDRESS}/amcosmosbika/locdd?subType=AIRPORT&keyword=${query}&countryCode=US`
//const svairporturl = `http://localhost:8000/amcosmosbika/locdd?subType=AIRPORT&keyword=${query}&countryCode=US`
 
//fetch(url,{method:'GET', agent:httpsAgent, headers:headers})
    /*
    fetch(svairporturl)
      .then((resp) => resp.json())
      .then((rs) => {
          const {data} = rs
          setIatas(data)
        setOptions(data);
        setIsLoading(false);
      });
  */

      axios.get(svairporturlBAse, {
        headers: headers, 
        validateStatus:false,
        params: {
          subType : 'AIRPORT',
          keyword : query,
          countryCode : 'US'
         
        }
      })
      .then((rs) => {
        const {data:{data}} = rs

        setIatas(data)
      setOptions(data);
      setIsLoading(false);
    });
    /*
    axios.get(svairporturl, {headers: headers, validateStatus:false})
    
      .then((rs) => {
        const {data} = rs
        setIatas(data)
      setOptions(data);
      setIsLoading(false);
    });
   */
    
};
  // Bypass client-side filtering by returning `true`. Results are already
  // filtered by the search endpoint, so no need to do it again.
  const filterBy = () => true;

  const handleTaDest = (obOptionDataMulti) => {
    setSelectedDest(selectedDest);
    console.log(obOptionDataMulti);
    let obOptionData = obOptionDataMulti[0]
    if(obOptionData){
        //let srcIdx =  obOptionData["_source"]
        let countryName = obOptionData["COUNTRY_NAME"]
        //let iata = srcIdx["ADDRESS_LINE1"]
        console.log(countryName)
       // setSvorg(iata)
        onSearchDesttxtFancy(countryName)
       // onSearchOrgtxtFancy(iata)
    }
  
};
  return (
      
    <AsyncTypeahead
      filterBy={filterBy}
      id="async-example2"
      isLoading={isLoading}
      labelKey="SOJOURN_NAME"
      minLength={3}
     
      onSearch={handleSearch}
      onChange={handleTaDest}
      
      options={iatas}
      placeholder="Search Sojourn Enter city name..."
      renderMenuItemChildren={(option) => (
        <>
             <div className="p-container-talist">
            <div className="p-container-talist-b1">
            <p className="m-para-text">
                                           
                                           <span style={{fontSize: "33px"}} > <Icon  style={{ color: '#c67a37' }} type="shop" theme="filled" /></span>
                                </p>                 
            </div>
            <div className="sp-container-talist-b2">
                  <div className="svo-container-orglist">
                                                      
                                                      <div className="svo-box-orglist-b1">
                                                           <span className="o-span"> {option.ADDRESS_LINE1},{option.STATE} {option.COUNTRY_NAME} </span>
                                                          
                                                          
                                                        </div>
                                                        <div className="svo-box-orglist-b2">
                                                             <span className="o-span">{option.SOJOURNCODE} </span>
                                                        </div>
                </div>
            </div>

          </div>
          
          <br/>
        </>
      )}
    />
  );
};
/* example-end */

export default SVRSojournDest;
